/**
 * The Settings > General > "Long-press on text" vocabulary, on its own with
 * no imports at all.
 *
 * It lives apart from touchSelection.ts (which acts on these values) because
 * settings/pages/general.ts needs them *at module-evaluation time* to build
 * its select, and settingsStore.ts → registry.ts → pages/general.ts is
 * already a cycle. Reaching them through touchSelection.ts — which imports
 * settingsStore — would put this file's constants inside that cycle, where
 * whichever module the graph happens to enter first decides whether they read
 * back as real values or as `undefined`.
 */

export type LongPressAction =
  /** Long-press selects; a second long-press on the selection opens the menu. */
  | "selectThenPress"
  /** Long-press selects; a floating button opens the menu (SelectionActionButton.tsx). */
  | "selectThenButton"
  /** Pre-existing behaviour: long-press opens the menu and never selects. */
  | "menu";

export const LONG_PRESS_ACTION_OPTIONS: { value: LongPressAction; label: string }[] = [
  { value: "selectThenPress", label: "Select the word — long-press again for actions" },
  { value: "selectThenButton", label: "Select the word — show a floating actions button" },
  { value: "menu", label: "Open the actions menu straight away" },
];

export const DEFAULT_LONG_PRESS_ACTION: LongPressAction = "selectThenPress";
